"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var _UISlider = _interopRequireDefault(require("UIComponents/input/UISlider"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _merchandiseUtils = require("pricing-pages-unified-ui/utils/merchandiseUtils");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  cursor: pointer;\n  font-size: 12px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-column-gap: 16px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MiddleGrid = _styledComponents.default.div.withConfig({
  displayName: "ContactsSlider__MiddleGrid",
  componentId: "kov4xp-0"
})(_templateObject());

var BottomLabel = _styledComponents.default.div.withConfig({
  displayName: "ContactsSlider__BottomLabel",
  componentId: "kov4xp-1"
})(_templateObject2());

var ContactsSlider = function ContactsSlider(props) {
  var _props$initialValue = props.initialValue,
      initialValue = _props$initialValue === void 0 ? 0 : _props$initialValue,
      _props$value = props.value,
      value = _props$value === void 0 ? null : _props$value,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? null : _props$onChange,
      min = props.min,
      _props$trackStart = props.trackStart,
      trackStart = _props$trackStart === void 0 ? min : _props$trackStart,
      max = props.max,
      step = props.step,
      title = props.title,
      description = props.description,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$numberInputCla = props.numberInputClassName,
      numberInputClassName = _props$numberInputCla === void 0 ? '' : _props$numberInputCla,
      _props$labelsBelowSli = props.labelsBelowSlider,
      labelsBelowSlider = _props$labelsBelowSli === void 0 ? false : _props$labelsBelowSli,
      restrictedAreaTooltip = props.restrictedAreaTooltip;
  var isFullyControlled = value != null;

  var _useState = (0, _react.useState)(initialValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      rawValue = _useState2[0],
      setRawValue = _useState2[1];

  var calculatedValue = (0, _merchandiseUtils.createSteppingFunction)(min, max, step)(rawValue);
  (0, _react.useEffect)(function () {
    if (!isFullyControlled && onChange) {
      onChange(calculatedValue);
    }
  }, [isFullyControlled, calculatedValue]);
  var displayValue = isFullyControlled ? value : calculatedValue;

  var handleValueChange = function handleValueChange(newRawValue) {
    if (isFullyControlled) {
      if (onChange) onChange(newRawValue);
    } else {
      setRawValue(newRawValue);
    }
  };

  return _react.default.createElement("div", null, title, _react.default.createElement(MiddleGrid, null, _react.default.createElement("div", null, description), _react.default.createElement("div", null, _react.default.createElement(_UINumberInput.default, {
    value: displayValue,
    onChange: function onChange(_ref) {
      var newValue = _ref.target.value;
      return handleValueChange(newValue);
    },
    disabled: disabled,
    className: numberInputClassName,
    "data-selenium-id": "contacts-picker-input"
  }))), _react.default.createElement("div", {
    className: "p-top-5"
  }, _react.default.createElement(_UISlider.default, {
    size: "large",
    min: min,
    minLabel: _react.default.createElement(_FormattedNumber.default, {
      value: trackStart
    }),
    trackStart: trackStart,
    max: max,
    maxLabel: _react.default.createElement(_FormattedNumber.default, {
      value: max
    }),
    value: displayValue,
    showLabels: !labelsBelowSlider,
    onChange: function onChange(_ref2) {
      var newValue = _ref2.target.value;
      return handleValueChange(newValue);
    },
    restrictedAreaTooltip: restrictedAreaTooltip,
    disabled: disabled
  })), labelsBelowSlider && _react.default.createElement("div", {
    className: "flex-row m-top-2"
  }, _react.default.createElement(BottomLabel, {
    onClick: function onClick() {
      return handleValueChange(trackStart);
    }
  }, _react.default.createElement(_FormattedNumber.default, {
    value: min
  })), _react.default.createElement(BottomLabel, {
    className: "m-left-auto",
    onClick: function onClick() {
      return handleValueChange(max);
    }
  }, _react.default.createElement(_FormattedNumber.default, {
    value: max
  }))));
};

ContactsSlider.propTypes = {
  initialValue: _propTypes.default.number,
  value: _propTypes.default.number,
  min: _propTypes.default.number.isRequired,
  trackStart: _propTypes.default.number,
  max: _propTypes.default.number.isRequired,
  step: _propTypes.default.number.isRequired,
  title: _propTypes.default.node.isRequired,
  description: _propTypes.default.node.isRequired,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  numberInputClassName: _propTypes.default.string,
  labelsBelowSlider: _propTypes.default.bool,
  restrictedAreaTooltip: _propTypes.default.node
};
var _default = ContactsSlider;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/ContactsSlider.js
// module id = 504
// module chunks = 5 6